module.exports = __webpack_public_path__ + "img/bg.7003081d.jpeg";